import { agDetailCol, agEndDateCol, agPriceCol, agStartDateCol, agStatusCol } from '@/ag-grid/ag-columns'
import { priceRenderer, priceWithCurrencyRenderer } from '@lib/generic.utils'

function costPerUseColumn(colName, currency, colId) {
  return {
    headerName: colName,
    type: 'rightAligned',
    cellRenderer: params => {
      if (Number(params.value)) return `${params.value} <small>${params.data[currency]}</small>`
      return 'N/A'
    },
    valueGetter: params => {
      const price = params.getValue(colId)
      const usage = params.getValue(this.subscription.usage_column.field)
      const res = Number(price) / Number(usage)
      if ([Infinity, -Infinity, NaN, 0].includes(res)) return 0
      return res.toFixed(2)
    }
  }
}

export const gridOptions = {
  computed: {
    gridOptions() {
      return {
        columnDefs: [
          agStatusCol(),

          agStartDateCol(),

          agEndDateCol({ sort: 'asc' }),

          agDetailCol({ hide: false }),

          agPriceCol(this.subscription.usage_column.value, this.subscription.usage_column.field, {
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell'],
            cellRenderer: params => priceRenderer(params.value, 0),
            cellEditorParams: {
              decimals: '0'
            }
          }),

          agPriceCol('Final Price', 'price'),

          costPerUseColumn.call(this, 'Cost per use (Original Currency)', 'currency', 'price'),

          agPriceCol('Price in Local Currency', 'normalized_price', {
            cellRenderer: params => priceWithCurrencyRenderer(params, 'normalized_currency')
          }),

          costPerUseColumn.call(this, 'Cost per use (Local Currency)', 'normalized_currency', 'normalized_price')
        ],
        domLayout: 'autoHeight'
      }
    }
  }
}
